<template>
  <v-card class="py-8 px-6">
    <v-form ref="editClientForm" v-model="validClientForm" @submit.prevent="updateClientDetails">
      <div class="grid grid-cols-2 gap-x-4">
        <v-select v-if="isFirma" v-model="country" class="col-span-2 w-1/2 pr-2" :items="countryItems"
          item-text="name" item-value="code" label="Tara" outlined dense :rules="[rules.required]">
          <template v-slot:item="{ item }">
            <span class="mr-3">{{ item.flag }}</span>
            <span>{{ item.name }}</span>
          </template>
          <template v-slot:selection="{ item }">
            <span class="mr-3">{{ item.flag }}</span>
            <span>{{ item.name }}</span>
          </template>
        </v-select>
        <v-text-field v-if="isFirma" :label="companyFields.vatLabel" :hint="companyFields.vatHint" text outlined dense
          :rules="[rules.required, rules.vat]" v-model="client.cui"></v-text-field>
        <v-text-field v-if="isFirma" :label="companyFields.regLabel" :hint="companyFields.regHint" text outlined dense
          :rules="isRoCompany ? [rules.required] : []" v-model="client.reg_com"></v-text-field>
        <v-text-field :label="isFirma ? 'Denumire' : 'Nume si prenume'" text outlined dense :rules="[rules.required]"
          v-model="client.nume"></v-text-field>
        <v-text-field v-if="isFirma" label="Nume persoana" text outlined dense :rules="[rules.required]"
          v-model="client.persoana"></v-text-field>
        <v-text-field class="col-span-2" label="Adresa" text outlined dense v-model="client.adresa"></v-text-field>
        <v-text-field label="Email" text outlined dense :rules="[rules.email, rules.isEmailOrPhone]"
          v-model="client.email"></v-text-field>
        <v-text-field label="Telefon" text outlined dense :rules="[rules.phone, rules.isEmailOrPhone]"
          v-model="client.tel"></v-text-field>
      </div>
      <div class="flex flex-row justify-end gap-2 mt-4">
        <v-btn color="blue-grey" class="uppercase" dark large @click="$emit('cancelEdit')">Anuleaza</v-btn>
        <v-btn color="teal" dark class="uppercase" large type="submit">Salveaza</v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import flags from "@/assets/countries-flags.json"
import { companyCountries, getCompanyFields, normalizeVatNo } from "@/utils"

export default {
  name: 'EditClient',
  props: {
    clientData: Object
  },
  data() {
    return {
      client: { ...this.clientData },
      // firmele adaugate inainte de tarile UE nu au tara salvata, sunt firme romanesti
      country: this.clientData.client_country || 'ro',
      validClientForm: false,
      rules: {
        required: value => !!value || 'Câmp obligatoriu',
        vat: value => !value || this.companyFields.vatFormat.test(value.replace(/[\s.-]/g, "")) || 'Cod fiscal invalid',
        regcom: value => !value || /^([J|j]|[F|f]|[C|c])[0-9]{2}\/[0-9]+\/(19|20)([0-9]{2})$/.test(value) || 'Număr înregistrare incorect',
        email: value => !value || /.+@.+\..+/.test(value) || "Adresa email invalida",
        isEmailOrPhone: () => this.isEmailOrPhone || "Email sau telefon obligatoriu",
        phone: value => !value || /(\(?\+?\d{1,4}\)?\s?)?\d{6,12}/.test(value) || "Numar incorect",
      }
    }
  },
  computed: {
    isEmailOrPhone() {
      return !!this.client.tel || !!this.client.email
    },
    isFirma() {
      return !!+this.client.firma
    },
    countryItems() {
      return companyCountries.map(country => ({
        ...country,
        flag: flags[country.code.toUpperCase()].emoji
      }))
    },
    companyFields() {
      return getCompanyFields(this.country)
    },
    isRoCompany() {
      return this.isFirma && this.country == 'ro'
    },
  },
  watch: {
    country(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$refs.editClientForm.resetValidation();
      }
    }
  },
  methods: {
    async updateClientDetails() {
      const valid = await this.$refs.editClientForm.validate();

      if (valid) {
        let updClient = {
          nume: this.client.nume,
          cui: this.isFirma ? normalizeVatNo(this.client.cui, this.country) : this.client.cui,
          reg_com: this.client.reg_com,
          adresa: this.client.adresa,
          oras: this.client.oras,
          // pe persoane fizice nu se poate alege tara, deci o lasam cum a venit (lead-urile din configurator o au setata)
          client_country: this.isFirma ? this.country : this.client.client_country,
          persoana: this.client.persoana,
          email: this.client.email,
          cc_obj: JSON.stringify(this.client.cc_obj),
          tel: this.client.tel
        }

        let id = this.$route.params.id
        this.$store.dispatch('updClient', { object: updClient, id: id })
        this.$emit('cancelEdit')
      }
    }
  },
  created() {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
